import { defineMessages } from 'react-intl';

export default defineMessages({
    emailAddressLabel: {
        defaultMessage: 'Email address',
        description: 'Label of email field on complete sign up page',
        id: 'cv.complete.sign.up.field.email',
    },
    fullNameLabel: {
        defaultMessage: 'Full name',
        description: 'Label for complete sign up form full name field',
        id: 'cv.complete.sign.up.full.name.label',
    },
    passwordLabel: {
        defaultMessage: 'Choose a password',
        description: 'Label for complete sign up form password field',
        id: 'cv.complete.sign.up.password.label',
    },
    signUpConditions: {
        defaultMessage:
            'By clicking {signUpButtonLabel}, you agree to the {privacyPolicyLink} and this {noticeAndDisclaimerLink}.',
        description: 'Conditions that apply when the sign up button is clicked',
        id: 'cv.complete.sign.up.conditions',
    },
    privacyPolicyLinkText: {
        defaultMessage: 'Privacy Policy',
        description: 'Privacy policy link text',
        id: 'cv.complete.sign.up.privacy.policy.link.text',
    },
    noticeAndDisclaimerLinkText: {
        defaultMessage: 'Notice and Disclaimer',
        description: 'Notice and disclaimer link text',
        id: 'cv.complete.sign.up.notice.and.disclaimer.link.text',
    },
    submitButton: {
        defaultMessage: 'Sign up',
        description: 'Complete sign up form submit button',
        id: 'cv.complete.sign.up.submit.button',
    },
    errorMessageContactLink: {
        defaultMessage: 'tell us about this issue',
        description: 'Text inside the refresh link inside the error banner.',
        id: 'cv.complete.sign.up.error.contact.link',
    },
});
